<template>
    <div>
        <a href="#" @click.prevent="() => !disabled ? lightboxVisible = true : null">
            <slot name="default"></slot>
        </a>
        <teleport to="body">
            <vue-easy-lightbox
                :imgs="photosUrl"
                :visible="lightboxVisible"
                @hide="() => lightboxVisible = false"
                loop="true"
            >
                <template #prev-btn="{ prev }">
                    <action-button v-if="isLightboxArrowsVisible" @click="prev" variant="primary" icon="fa-solid fa-chevron-left" class="lightbox-btn prev" />
                </template>
                <template #next-btn="{ next }">
                    <action-button v-if="isLightboxArrowsVisible" @click="next" variant="primary" icon="fa-solid fa-chevron-right" class="lightbox-btn next" />
                </template>
            </vue-easy-lightbox>
        </teleport>
    </div>
</template>

<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { Resource } from '@/modules/core/files/services/StorageService';
import { Options, Vue } from 'vue-class-component';
import VueEasyLightbox from 'vue-easy-lightbox';

@Options({
    components: { VueEasyLightbox }
})
export default class RenterPhotoPreview extends Vue
{
    @Prop() public photos: Resource[];
    @Prop({ default: false }) public disabled: boolean;

    public get photosUrl(): Array<string>
    {
        return this.photos.map((photo: Resource) => `${this.$filters.baseurl(photo.url)}`);
    }

    public lightboxVisible: boolean = false;

    public get isLightboxArrowsVisible(): boolean
    {
        return this.photosUrl.length > 1;
    }
}
</script>

<style lang="scss" scoped>
.lightbox-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &.prev {
        left: 5px;

        @media (min-width: 568px) {
            left: 20px;
        }
    }

    &.next {
        right: 5px;

        @media (min-width: 568px) {
            right: 20px;
        }
    }
}
</style>
